const MEDIA_ITEMS = [
  {
    title: '热血战斗名场面精选',
    desc: '从鬼灭之刃的火之神乐到咒术回战的领域展开，收录近年最燃战斗名场面',
    img: 'https://readdy.ai/api/search-image?query=Epic%20manga%20style%20battle%20scene%20with%20two%20warriors%20clashing%20in%20dramatic%20combat%2C%20explosive%20energy%20effects%20in%20warm%20orange%20and%20golden%20colors%2C%20dynamic%20action%20composition%2C%20Japanese%20anime%20art%20style%2C%20cinematic%20lighting%2C%20intense%20atmosphere&width=1200&height=800&seq=media-gallery-01&orientation=landscape',
    tag: '战斗精选',
  },
  {
    title: '治愈系日常暖心时刻',
    desc: '间谍过家家、跃动青春等作品的温暖瞬间，治愈你的每一个平凡日常',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20manga%20style%20illustration%20of%20characters%20sharing%20a%20peaceful%20everyday%20moment%20in%20a%20cozy%20setting%2C%20soft%20warm%20lighting%20with%20cream%20and%20peach%20tones%2C%20Japanese%20anime%20art%20style%2C%20gentle%20atmosphere%2C%20slice%20of%20life%20aesthetic&width=1200&height=800&seq=media-gallery-02&orientation=landscape',
    tag: '治愈合集',
  },
  {
    title: '奇幻异世界冒险之旅',
    desc: '从转生史莱姆到迷宫饭，带你穿越一个个充满想象力的异世界大陆',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20style%20illustration%20of%20adventurers%20exploring%20a%20magical%20landscape%20with%20floating%20islands%20and%20ancient%20ruins%2C%20warm%20golden%20sunset%20lighting%2C%20rich%20environmental%20details%2C%20Japanese%20anime%20art%20style%2C%20grand%20scale%20composition&width=1200&height=800&seq=media-gallery-03&orientation=landscape',
    tag: '奇幻冒险',
  },
  {
    title: '悬疑推理高能反转',
    desc: '那些让人拍案叫绝的剧情反转，搜集悬疑漫画中最精彩的推理时刻',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20manga%20style%20illustration%20of%20a%20detective%20character%20in%20a%20dimly%20lit%20room%20with%20clues%20and%20evidence%20boards%2C%20atmospheric%20warm%20lighting%20with%20amber%20accents%2C%20Japanese%20anime%20art%20style%2C%20suspenseful%20mood%2C%20noir%20inspired%20composition&width=1200&height=800&seq=media-gallery-04&orientation=landscape',
    tag: '推理精选',
  },
  {
    title: '经典名作不朽篇章',
    desc: '海贼王、龙珠、灌篮高手等世代传承的经典漫画，每一个篇章都是回忆',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20manga%20style%20illustration%20of%20classic%20adventure%20characters%20journeying%20toward%20a%20bright%20horizon%2C%20warm%20vintage-inspired%20golden%20and%20sepia%20tones%2C%20Japanese%20anime%20art%20style%2C%20emotional%20composition%2C%20timeless%20atmosphere&width=1200&height=800&seq=media-gallery-05&orientation=landscape',
    tag: '经典回顾',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-image-line text-accent-600 text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">作品精选</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <article
              key={i}
              className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative w-full overflow-hidden bg-background-100 ${i === 0 ? 'aspect-[16/9] lg:aspect-[16/10]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  title={`${item.title} - 爱漫画网作品精选`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="text-[10px] md:text-xs font-semibold text-background-50 bg-accent-500/85 px-2.5 py-1 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}